import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { DailySalesCategoryAmountStaff } from "./DailySalesCategoryAmountStaff";
import type { DailySalesPaymentTypeAmountStaff } from "./DailySalesPaymentTypeAmountStaff";
import type { DailySalesReportDTOBase } from "./DailySalesReportDTOBase";
import type { DailySalesTotalsBase } from "./DailySalesTotalsBase";
import type { ReportRunRef } from "./ReportRunRef";

export class DailySalesReportStaff implements DailySalesReportDTOBase, DailySalesTotalsBase {
  constructor(public readonly rowId: number, public readonly runId: ReportRunRef, public readonly forDate: Date, public readonly categoryAmounts: Array<DailySalesCategoryAmountStaff> | null, public readonly paymentTypeAmounts: Array<DailySalesPaymentTypeAmountStaff> | null, public readonly totalAmountItems: number, public readonly totalAmountRefunded: number, public readonly netAmountItems: number, public readonly totalAmountPayments: number, public readonly totalOrders: number, public readonly totalItems: number, public readonly totalPayments: number) {
    this.cbiServiceContext = null;
    this.categoryAmountsLoaded = this.categoryAmounts != null;
    this.categoryAmountsCached = this.categoryAmounts;
    this.paymentTypeAmountsLoaded = this.paymentTypeAmounts != null;
    this.paymentTypeAmountsCached = this.paymentTypeAmounts;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private categoryAmountsLoaded: boolean;
  private categoryAmountsCached: Array<DailySalesCategoryAmountStaff> | null;
  private paymentTypeAmountsLoaded: boolean;
  private paymentTypeAmountsCached: Array<DailySalesPaymentTypeAmountStaff> | null;
  async categoryAmountsLazy(): Promise<Array<DailySalesCategoryAmountStaff>> {
    if (!this.categoryAmountsLoaded) {
      this.categoryAmountsCached = await this.cbiServiceContext!.reportService().getDailySalesReportStaffCategoryAmounts(this.rowId);
      this.categoryAmountsLoaded = true;
    }
    return this.categoryAmountsCached!;
  }
  async paymentTypeAmountsLazy(): Promise<Array<DailySalesPaymentTypeAmountStaff>> {
    if (!this.paymentTypeAmountsLoaded) {
      this.paymentTypeAmountsCached = await this.cbiServiceContext!.reportService().getDailySalesReportStaffPaymentTypeAmounts(this.rowId);
      this.paymentTypeAmountsLoaded = true;
    }
    return this.paymentTypeAmountsCached!;
  }
}
